export const TEST_SITE_ACCESS_COOKIE_NAME = "eco_tour_test_site_access";
export const TEST_SITE_ACCESS_TTL_MS = 24 * 60 * 60 * 1000;
export const TEST_SITE_ACCESS_PIN = "970450559611";
export const TEST_SITE_REQUIRED_CONFIRMATION = "i understand that its test site and i am from developer team";

const TEST_SITE_ACCESS_COOKIE_VERSION = "v1";
const SHARED_TEST_COOKIE_DOMAIN = ".ecotour.teceads.co.in";

const normalizeText = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const isBrowser = () => typeof document !== "undefined";

const resolveCookieDomain = () => {
  if (typeof window === "undefined") return "";
  const hostname = String(window.location?.hostname || "").trim().toLowerCase();
  if (hostname === "ecotour.teceads.co.in" || hostname.endsWith(".ecotour.teceads.co.in")) {
    return SHARED_TEST_COOKIE_DOMAIN;
  }
  return "";
};

const buildCookieAttributes = ({ maxAgeSeconds, expires, domain } = {}) => {
  const secure = typeof window !== "undefined" && window.location?.protocol === "https:";
  return [
    "Path=/",
    "SameSite=Lax",
    `Max-Age=${Math.max(0, Number(maxAgeSeconds) || 0)}`,
    expires ? `Expires=${expires.toUTCString()}` : "",
    domain ? `Domain=${domain}` : "",
    secure ? "Secure" : "",
  ]
    .filter(Boolean)
    .join("; ");
};

export const normalizeTestSiteConfirmation = normalizeText;

export const isValidTestSiteConfirmation = (value) =>
  normalizeText(value) === TEST_SITE_REQUIRED_CONFIRMATION;

export const isValidTestSiteAccessInput = ({ confirmation = "", pin = "" } = {}) =>
  isValidTestSiteConfirmation(confirmation) && String(pin || "").trim() === TEST_SITE_ACCESS_PIN;

export const readCookie = (name) => {
  if (!isBrowser()) return "";
  const encodedName = `${encodeURIComponent(name)}=`;
  const pair = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(encodedName));
  return pair ? decodeURIComponent(pair.slice(encodedName.length)) : "";
};

export const clearTestSiteAccessCookie = (name = TEST_SITE_ACCESS_COOKIE_NAME) => {
  if (!isBrowser()) return;
  const expires = new Date(0);
  const hostAttributes = buildCookieAttributes({ maxAgeSeconds: 0, expires });
  document.cookie = `${encodeURIComponent(name)}=; ${hostAttributes}`;

  const sharedDomain = resolveCookieDomain();
  if (sharedDomain) {
    const sharedAttributes = buildCookieAttributes({ maxAgeSeconds: 0, expires, domain: sharedDomain });
    document.cookie = `${encodeURIComponent(name)}=; ${sharedAttributes}`;
  }
};

export const setTestSiteAccessCookie = (name = TEST_SITE_ACCESS_COOKIE_NAME) => {
  if (!isBrowser()) return;
  const now = Date.now();
  const expires = new Date(now + TEST_SITE_ACCESS_TTL_MS);
  const value = `${TEST_SITE_ACCESS_COOKIE_VERSION}.${now}`;
  const maxAgeSeconds = Math.floor(TEST_SITE_ACCESS_TTL_MS / 1000);
  const attributes = buildCookieAttributes({
    maxAgeSeconds,
    expires,
    domain: resolveCookieDomain(),
  });
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ${attributes}`;
};

export const hasValidTestSiteAccessCookie = (name = TEST_SITE_ACCESS_COOKIE_NAME) => {
  const value = readCookie(name);
  if (!value) return false;

  const [version, timestamp] = value.split(".");
  const acknowledgedAt = Number(timestamp);
  if (version !== TEST_SITE_ACCESS_COOKIE_VERSION || !Number.isFinite(acknowledgedAt)) {
    clearTestSiteAccessCookie(name);
    return false;
  }

  if (Date.now() - acknowledgedAt >= TEST_SITE_ACCESS_TTL_MS) {
    clearTestSiteAccessCookie(name);
    return false;
  }

  return true;
};
